export enum DeviceAlertTypeSummary {
    ETHERNET_INTERFACE_CHAGNE = "ethernetInterfaceChange",
    WEB_UI_LOGIN_FAILURE = "webUILoginFailure",
    BANDWIDTH = "bandwidth",
    CELL_BOUNCING = "cellBouncing",
    CONFIGURATION = "config",
    DOWNTIME = "downtime",
    FAILOVER = "failover",
    FIRMWARE = "updateFW",
    IP_CHANGE = "ipChange",
    UNIT_POWERED_UP = "reboot",
    RF = "rf",
    TEMPERATURE = "temperature",
    DRY_CONTACT = "dryContact",
    NETWORK_TECHNOLOGY_CHANGE = "networkTechnologyChange",
    SERIAL_CONNECTOR = "serialConnector",
    PCI_HOPPING = "PciHopping",
    GEO_FENCE = "geoFence"
};

export enum DeviceAlertType {
    ETHERNET_INTERFACE_CHAGNE = "ethernetInterfaceChange",
    WEB_UI_LOGIN_FAILURE = "webUILoginFailure",
    BANDWIDTH = "bandwidth",
    CELL_BOUNCING = "cellBouncing",
    CONFIGURATION = "config",
    DOWNTIME = "downtime",
    FAILOVER = "failover",
    FIRMWARE = "updateFW",
    IP_CHANGE = "ipChange",
    UNIT_POWERED_UP = "reboot",
    TEMPERATURE = "temperature",
    LICENSE = "license",
    RSRP = "RSRP",
    RSRQ = "RSRQ",
    RSSI = "RSSI",
    SINR = "SINR",
    NR_RSRP = "NR_RSRP",
    NR_RSRQ = "NR_RSRQ",
    NR_SINR = "NR_SINR",
    DRY_CONTACT = "dryContact",
    NETWORK_TECHNOLOGY_CHANGE = "networkTechnologyChange",
    SERIAL_CONNECTOR = "serialConnector",
    PCI_HOPPING = "PciHopping",
    GEO_FENCE = "geoFence"
};

export type DeviceAlertTypeNameMap = {
    [key in DeviceAlertType | string]: string
};

export type DeviceAlertTypeSummaryInitial = {
    [key in DeviceAlertTypeSummary]: number
};

export enum AlertClass {
    CRITICLE = "criticle",
    WARNING = "warning",
    INFO = "info",
    OTHER = "other"
};

export type SeverityFilter = {
    [key in AlertClass]?: boolean
};